<script setup lang="ts"></script>

<template>
  <v-card v-bind="$attrs">
    <slot />
  </v-card>
</template>
